import { checkTokenExpiry } from "../fetching/fetchingAuth";

export const checkToken = (tokenSetter, loginSetter, credentialsSetter) => {
    const localToken = localStorage.getItem("jwt");
    tokenSetter(localToken)
    if (localToken) {
        checkTokenExpiry(localToken).then(
          response => {
            if (!response.notExpired) {
                loginSetter(false);
              localStorage.removeItem("jwt");
            } else {
                loginSetter(true);
              if (response.credentials) {
                credentialsSetter(response.credentials);
              }
            }
          }
        ).catch(e => {
            loginSetter(false)
          localStorage.removeItem("jwt");
        });
    } else {
        loginSetter(false);
    }
}